import React, { useLayoutEffect, useRef, useState } from 'react'
import { indexVerseSource } from '../../lib/ledgerVerseLayout'

/** Size from the whole source, not the currently rendered/filtered rows. */
export function LedgerVerseColumn({ source, className }: { source: string; className: string }) {
  const ref = useRef<HTMLTableColElement>(null)
  const [width, setWidth] = useState<number>()
  useLayoutEffect(() => {
    const index = indexVerseSource(source)
    const table = ref.current?.closest('table')
    if (!index || !table) { setWidth(undefined); return }
    const probe = document.createElement('span')
    probe.className = 'font-reader-arabic text-sm'
    probe.style.cssText = 'position:absolute;visibility:hidden;pointer-events:none'
    table.parentElement?.appendChild(probe)
    let disposed = false
    const measure = () => {
      if (disposed) return
      const style = getComputedStyle(probe)
      const ctx = document.createElement('canvas').getContext('2d')
      if (!ctx) return
      ctx.font = `${style.fontWeight} ${style.fontSize} ${style.fontFamily}`
      const half = Math.ceil(Math.max(...index.halves.map(h => ctx.measureText(h.text).width))) + 2
      // Two halves, existing 28px gutter, cell padding and arrow clearance.
      setWidth(Math.max(260, half * 2 + 28 + 64))
    }
    measure()
    document.fonts?.ready.then(measure)
    document.fonts?.addEventListener('loadingdone', measure)
    window.addEventListener('resize', measure)
    return () => {
      disposed = true; probe.remove()
      document.fonts?.removeEventListener('loadingdone', measure)
      window.removeEventListener('resize', measure)
    }
  }, [source])
  return <col ref={ref} className={className} style={{ width }} />
}
